import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';
import ListReceiveAddress from './ListReceiveAddress';
import _ from "lodash";
import { MIXAY_KEY } from '../../../../constants';

const ReceiveDeliveryAddress = ({ userAddress, setIsReceiveData, userConfirm, psid, orderGroup }) => {
    const [isAddModal, setIsAddModal] = useState(false);
    const onCloseModalAdd = () => setIsAddModal(false);

    // CHECK USER ADDRESS
    const [idSelect, setIdSelect] = useState('');
    const [isSelect, setIsSelect] = useState(false);
    const [isDataSelect, setIsDataSelect] = useState({});
    const [isUserAddress, setIsUserAddress] = useState({});
    useEffect(() => {
        // find array user address by default = true
        const findDefaultAddress = userAddress.filter((address) => address.default === true);
        if (!_.isEmpty(findDefaultAddress)) {
            setIsUserAddress(findDefaultAddress[0]);
        } else {
            setIsUserAddress(userAddress[0]);
        }
    }, [userAddress]);

    useEffect(() => {
        setIsReceiveData(isUserAddress);
        setIdSelect(isUserAddress?.id);
    }, [isUserAddress]);

    useEffect(() => {
        if (isSelect) {
            setIsReceiveData(isDataSelect);
            setIsUserAddress(isDataSelect);
            setIsSelect(false);
        }
    }, [isDataSelect]);

    const newAddress = (value) =>{
        return value?.deliveryName === MIXAY_KEY 
        ? `${value?.branchCode}-${value?.village}-${value?.district}-${value?.province}`
        : value?.address || "Address not found...";
    }

    return (
        <>
            {!_.isEmpty(isUserAddress) &&
                <div style={{
                    border: '1px solid #E5E5E5',
                    padding: '15px',
                    borderRadius: '5px',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>

                    {/* Address Icon and Title */}
                    {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FaMapMarkerAlt style={{ color: 'orange', fontSize: '24px', marginRight: '10px' }} />
                            <div> */}
                    {isUserAddress?.deliveryName === "OF_POINT" ? (
                        <p style={{ width: 130, height: 35, marginRight: 5 }}>ຮັບເຄື່ອງຫນ້າຮ້ານ: ຂໍ້ມູນສ່ວນຕົວ:</p>
                    ) : (
                        <img
                            style={{ width: 30, height: 30, marginRight: 5, borderRadius: '55em' }}
                            src={isUserAddress?.img}
                            alt={isUserAddress?.deliveryName}
                        />
                    )}

            {/* Address Information */}
            <div div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px', flexGrow: 1, }}>
                <div style={{ fontWeight: 'bold', fontSize: 12 }}>{`${isUserAddress?.userName} (+856) ${isUserAddress?.userTel}`}</div>
                {/* <div style={{ fontSize: 12 }}>{isUserAddress?.address}</div> */}
                <div style={{ fontSize: 12 }}>{newAddress(isUserAddress)}</div>
            </div>


            {/* Action Buttons */}
            < div style={{ display: 'flex', alignItems: 'center' }}>
                {isUserAddress?.latLong && (
                    <Button size="sm" style={{ marginRight: '10px' }}>
                        <a href={isUserAddress?.latLong} target="google_map" className="btn btn-sm btn-primary">
                            ແຜ່ນທີ່
                        </a>
                    </Button>
                )}
                {/*
                   (
                        <Button variant="outline-danger" size="sm" style={{ marginRight: '10px' }} disabled>
                            Default
                        </Button>
                        ) 
                   */}
                <Button variant="link" size="sm" style={{ color: '#007bff' }} onClick={() => setIsAddModal(true)}>
                    ແກ້ໄຂ
                </Button>
                <Modal centered show={isAddModal}>
                    <Modal.Header >
                        <Modal.Title>📝📝📝 ທີ່ຢູ່ສຳລັບການຈັດສົ່ງ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ListReceiveAddress userId={isUserAddress?.user} userConfirm={userConfirm} psid={psid}
                            idSelect={idSelect} setIdSelect={setIdSelect}
                            onClose={onCloseModalAdd}
                            setIsDataSelect={setIsDataSelect}
                            setIsSelect={setIsSelect}
                            orderGroup={orderGroup}
                        />
                    </Modal.Body>
                </Modal>
            </div >
        </div >
            }
        </>
    );
};

export default ReceiveDeliveryAddress;
